<template>
    <div>
    <div v-for="bookingInvoiceData in bookingInvoicesData ">
        <payment     :logged-user='loggedUser'
                     :item-type="itemType"
                     :can-see-customer="canSeeCustomer"
                     :show-payment-modal-earning="showPaymentModalEarning"
                     :currency='currency'
                     @modalOpened="modalOpened"
                     :booking-invoice='bookingInvoiceData'
                     :booking-payment-summary='bookingPaymentSummary'
                     :booking-nums='bookingNums'
                     :has-recurring='hasRecurring'
                     :company-has-default-payment-gateway="companyHasDefaultPaymentGateway"
                     :view-page="true"
                     :show-view-invoice-popup="showViewInvoicePopup">
        </payment>
    </div>
    </div>
</template>

<script>
import Payment from "@/modules/Payment/components/Payment.vue";

export default {
    name: "Payments",
    components: {Payment},
    props: {
        itemType:null,
        showPaymentModalEarning:false,
        bookingPaymentSummary: {
            type: Object,
            required: true
        },
        bookingInvoices: {
            required: true
        },
        loggedUser: {
            required: true
        },
        currency: {
            default() {
                return {
                    currency_acronym: "AUD",
                    currency_fontAwsome: "fa fa-dollar",
                    currency_id: 51,
                    currency_name: "Australian dollar",
                    currency_symbol: "$",
                    currency_unicode: "f155",
                    recognized_in_pdf: 1

                }
            }
        },
        bookingNums: {
        },
        hasRecurring:false,
        companyHasDefaultPaymentGateway:true,
        viewPage:false,
        canSeeCustomer:null,

        showViewInvoicePopup:0
    },
    data() {
        return {
            bookingInvoicesData: this.bookingInvoices,
        }
    },
    methods: {
        modalOpened(value){
            this.$emit('modalOpened',value);

        },
},
}
</script>
